import React, { useEffect, useState } from 'react'
import { QuestionCircleTwoTone, SettingOutlined } from '@ant-design/icons'
import {
  Button,
  Col,
  Form,
  Input,
  Modal,
  notification,
  Popover,
  Radio,
  Row,
  Select,
  Switch,
} from 'antd'
import { useDispatch, useSelector } from 'react-redux'
import { RootDispatch } from '../../app/store'
import { unwrapResult } from '@reduxjs/toolkit'
import { getAcceptAsync } from './varietyManagement/varietyManagementSlice'
import { selectUserId } from '../../app/applicationSlice'
import { getBusinessAcceptAsync } from './businessManagement/businessManagementSlice'

const layout = {
  labelCol: { span: 5 },
  wrapperCol: { span: 19 },
}
export const GoForReviewModal = (props: {
  selectKey?: any
  id?: any
  acceptType?: any
  visible: boolean
  onOk: () => void
  onCancel: () => void
}) => {
  const dispatch = useDispatch<RootDispatch>()

  const userId = useSelector(selectUserId)

  const [buttonLoading, setButtonLoading] = useState(false)

  const [form] = Form.useForm()

  useEffect(() => {
    if (props?.visible) {
      form.setFieldsValue({
        acceptFlag: '1',
      })
    } else {
      form.resetFields()
    }
  }, [props?.visible])

  return (
    <div>
      <Modal
        title={'审核'}
        visible={props.visible}
        onOk={() => {
          props.onOk()
        }}
        onCancel={() => {
          form.resetFields()
          props.onCancel()
        }}
        footer={null}
      >
        <Form
          autoComplete='off'
          {...layout}
          form={form}
          name='basic'
          onFinish={(fs) => {
            setButtonLoading(true)
            const params = {
              ...fs,
              acceptType: props?.acceptType,
              id: props?.id,
              acceptUser: userId,
            }
            if (props?.selectKey == '0') {
              dispatch(getBusinessAcceptAsync({ ...params }))
                .then(unwrapResult)
                .then((v) => {
                  notification.success({
                    message: '操作成功',
                  })
                  props?.onOk()
                  form.resetFields()
                })
                .finally(() => {
                  setButtonLoading(false)
                })
            } else {
              dispatch(getAcceptAsync({ ...params }))
                .then(unwrapResult)
                .then((v) => {
                  notification.success({
                    message: '操作成功',
                  })
                  props?.onOk()
                  form.resetFields()
                })
                .finally(() => {
                  setButtonLoading(false)
                })
            }
          }}
        >
          <Col span={24}>
            <Form.Item
              name='acceptFlag'
              label='审核类型'
              rules={[{ required: true, message: '审核类型必填' }]}
            >
              <Radio.Group>
                <Radio value={'1'}>通过</Radio>
                <Radio value={'-1'}>不通过</Radio>
              </Radio.Group>
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item
              label='审核意见'
              name='opinion'
              rules={[
                { required: true, message: '审核意见必填' },
                {
                  max: 200,
                  message: '最长200位',
                },
              ]}
            >
              <Input.TextArea
                maxLength={200}
                showCount
                placeholder='请输入审核意见'
              />
            </Form.Item>
          </Col>
          <Row
            style={{
              width: '100%',
              marginTop: '40px',
              display: 'flex',
              justifyContent: 'flex-end',
            }}
          >
            <Button
              style={{ marginRight: '10px' }}
              onClick={() => {
                form.resetFields()
                props.onCancel()
              }}
            >
              取消
            </Button>
            <Button
              type='primary'
              loading={buttonLoading}
              onClick={() => {
                form.submit()
              }}
            >
              确认
            </Button>
          </Row>
        </Form>
      </Modal>
    </div>
  )
}
